import { usePersonSummaryCtx } from "../context/PersonSummaryContext";
import { useTripsCtx } from "../context/TripDetailsContext";
import { subscribePlan } from "../services/PaymentService/PaymentSubscriptionService";
import { SubscriptionType } from "../types/SubscriptionTypes";

export const useSubscriptionActions = () => {
  const { wandaOrgId } = useTripsCtx();
  const { isWandaConcierge, caregiverSummaryInfo } = usePersonSummaryCtx();

  const subscribeToWandaPlus = async (paymentInstrumentId: number) => {
    try {
      const subscriptionId = await subscribePlan(
        {
          subscriptionTypeId: SubscriptionType.WandaPlus,
          personId: caregiverSummaryInfo.personId,
          paymentInstrumentId: paymentInstrumentId,
          organizationId: wandaOrgId.privatePayId,
        },
        isWandaConcierge
      );

      return subscriptionId;
    } catch (error) {
      throw error;
    }
  };

  return {
    subscribeToWandaPlus,
  };
};
